export const weatherRemarkColumns: any[] = [
  {
    field: 'weatherReportSection',
    title: 'Weather Report Section',
    width: 100,
    minWidth: 100
  },
  {
    field: 'comment',
    title: 'Comment',
    width: 300,
    minWidth: 150
  },
];




// WEBPACK FOOTER //
// ./src/pages/weather-readings/weather-log-component/weather-remark-grid.config.ts